import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import { queryClient } from 'api/client';
import PostApi from 'api/post';
import i18n from 'app/utils/i18n';
import { queryKey } from 'constants/queryKey';
import { UserPermission } from 'constants/userPermission';
import { PostDetail } from 'types/PostDetail';
import { popupConfirm } from 'utils/popup';
import Logger from 'utils/logger';

export const deletePost = (context: ActionContext) =>
  createAction(
    {
      id: 'delete-post',
      label: () => i18n.t('moveToTrash', 'Move to trash'),
      icon: <Icon icon={faTrash} />,
      scopes: UserPermission.POST_DELETE,
      perform: async ({ id }: { id: PostDetail['id'] }) => {
        const result = await popupConfirm({
          title: i18n.t('moveToTrashConfirmTitle', 'Move this post to trash?'),
          confirmButtonText: i18n.t('moveToTrash', 'Move to trash'),
        });

        if (!result.isConfirmed) {
          return false;
        }

        try {
          await PostApi.moveToTrash(id);

          queryClient.invalidateQueries(queryKey.posts());
          queryClient.invalidateQueries(queryKey.postsMeta());
          queryClient.invalidateQueries(queryKey.dashboardPosts());
          queryClient.invalidateQueries(queryKey.dashboardFailedPosts());
          queryClient.invalidateQueries(queryKey.dashboardMyTasks());
          queryClient.invalidateQueries(queryKey.dashboardTasksStatus());
          queryClient.invalidateQueries(queryKey.trashedPosts());
          queryClient.invalidateQueries(queryKey.trashedPostsCount());

          if (window.location.pathname.includes('approvals/posts')) {
            queryClient.invalidateQueries(queryKey.approvalsPosts());
          }

          context.toast(
            i18n.t('postMovedToTrash', 'Post moved to trash'),
            'info',
          );

          return true;
        } catch (e) {
          Logger.error(e, 'delete-post-action');
          context.toast(
            i18n.t('unableToDeletePost', 'Unable to delete post'),
            'error',
          );

          return false;
        }
      },
    },
    context,
  );
